import React, { forwardRef } from "react";
import { cn } from "./cn";

/**
 * Bun inner nav: saved views, settings sections. Active item = mist-deep
 * chip + 600; inactive = slate 450 with mist hover. Optional count pill.
 * items: [{ id, label, count? }]
 */
export default function NavList({ items, active, onChange, className, ...props }) {
  return (
    <nav className={cn("flex flex-col gap-px font-instrument", className)} {...props}>
      {items.map((item) => {
        const isActive = item.id === active;
        const Icon = item.icon;
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onChange(item.id)}
            aria-current={isActive ? "true" : undefined}
            className={cn(
              "flex min-h-11 sm:min-h-0 items-center gap-[10px] text-left w-full px-[10px] py-[7px] rounded-[8px] cursor-pointer border-0 bg-transparent focus-visible:outline focus-visible:outline-2 focus-visible:outline-bun-blue",
              "text-bun-body",
              isActive
                ? "font-semibold text-bun-text bg-bun-mist-deep"
                : "font-book text-bun-slate hover:bg-bun-mist"
            )}
          >
            {Icon && <Icon aria-hidden="true" className="h-4 w-4 shrink-0" />}
            <span className="flex-1 min-w-0 truncate">{item.label}</span>
            {item.count != null && (
              <span className="ml-auto text-[10px] font-semibold bg-bun-ring text-bun-blue-hover rounded-full px-[6px] py-px">
                {item.count}
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
}

NavList.Item = forwardRef(function Item({ selected, title, description, status, variant, children, className, ...props }, ref) {
  const conversation = variant === 'conversation';
  return <button type="button" {...props} ref={ref} aria-current={selected ? 'page' : undefined} className={cn('flex min-h-11 w-full min-w-0 items-center gap-2 rounded-bun-lg px-2 py-2 text-left font-instrument focus-visible:outline focus-visible:outline-2 focus-visible:outline-bun-blue', conversation ? 'border' : 'border-0', selected ? (conversation ? 'border-bun-line bg-bun-chat-selected shadow-bun-card' : 'bg-bun-wash') : (conversation ? 'border-transparent bg-transparent hover:bg-bun-mist-deep group-hover:bg-bun-mist-deep' : 'bg-transparent hover:bg-bun-mist'), className)}>
    <span className="min-w-0 flex-1"><span className={cn('block truncate text-bun-body text-bun-text', conversation && !selected ? 'font-book' : 'font-strong')}>{title}</span>{description && <span className="mt-px block truncate text-bun-meta font-book text-bun-stone">{description}</span>}{children}</span>{status}
  </button>;
});
